import { Button, Modal } from '@mui/material';
import { FC, useState } from 'react';
import { StatusSelector } from '../common/StatusSelector';
import styles from '../Planning.module.scss';

export const BulkStatusModal: FC<{
    isOpen: boolean;
    close: () => void;
    submit: (s: string) => void;
}> = ({ isOpen, close, submit }) => {
    const [value, setValue] = useState<string>('');

    const onClose = () => {
        setValue('');
        close();
    };

    const onSubmit = () => {
        if (value) {
            submit(value);
            onClose();
        }
    };

    return (
        <Modal
            open={isOpen}
            keepMounted
            onClose={onClose}
            data-testid="BulkStatusModal"
        >
            <div className={styles.bulkStatusModal}>
                <h2>Status update</h2>
                {isOpen && (
                    <StatusSelector
                        value={value}
                        onChange={(v) => setValue(v)}
                    />
                )}
                <div className={styles.modalActions}>
                    <Button variant="outlined" onClick={onClose}>
                        Close
                    </Button>
                    <Button
                        variant="contained"
                        disabled={!value}
                        onClick={onSubmit}
                    >
                        Confirm
                    </Button>
                </div>
            </div>
        </Modal>
    );
};
